import React from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import LandingPage from './LandingPage';
import Dashboard from './pages/Dashboard/Dashboard.js';
import Service from './pages/ServiceProvider';
import ServiceRequests from './pages/ServiceRequests';
import Homeowner from './pages/Homeowner.jsx';
import Login from './pages/Login_Signup/index.js';

const Home = ({handleLogin}) => {
  return (
    <BrowserRouter>
       <LandingPage handleLogin={handleLogin}> 
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/service" element={<Service />} />
          <Route path="/serviceRequests" element={<ServiceRequests />} />
          <Route path="/homeowner" element={<Homeowner />} />
          <Route path="/login" element={<Login />} />
        </Routes>
      </LandingPage>
    </BrowserRouter>
  );
};

export default Home;
